import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../lib/redux/hooks";
import CheckboxGroup from "../../ui/molecules/CheckBoxGroup";
import { MadfarmStaticSelect } from "../../ui/molecules/select/newSelect/static";
import { tipoSoggetto } from "../../utils";
import { setCustomerCreateRequestField, setCustomerUpdateRequestField } from "../clienti/feature/slice";

interface Props {
    mode?: "create" | "edit"
}

export function ProduzioneIntegrata({ mode }: Props) {
    const customerState = useAppSelector((state) => state.customer);
    const dispatch = useAppDispatch()

    const [selectedTypes, setSelectedTypes] = useState<CohesionType[]>([]);

    enum CohesionType {
        TERRENI = "TERRENI",
        TRASFORMAZIONE_CONFEZIONAMENTO = "TRASFORMAZIONE_CONFEZIONAMENTO",
        INTERMEDIAZIONE = "INTERMEDIAZIONE",
        COMMERCIALIZZAZIONE_PRODOTTO_SFUSO = "COMMERCIALIZZAZIONE_PRODOTTO_SFUSO"
    }

    useEffect(() => {
        if (customerState.getCustomerByIdResponse !== undefined && mode === "edit") {
            dispatch(setCustomerUpdateRequestField({ field: "sqnpiSubjectType", value: customerState.getCustomerByIdResponse.sqnpiSubjectType }));
            const adhesionTypes = customerState.getCustomerByIdResponse.sqnpiAdhesionType.map((type: string) => CohesionType[type as keyof typeof CohesionType]);
            dispatch(setCustomerUpdateRequestField({ field: "sqnpiAdhesionType", value: adhesionTypes }));
            setSelectedTypes(adhesionTypes)
        }
    }, [customerState.getCustomerByIdResponse]);

    const handleTypesChange = (value: CohesionType) => {
        let currentTypes = [...selectedTypes];
        if (currentTypes.includes(value)) {
            currentTypes = currentTypes.filter(t => t !== value);
            setSelectedTypes(currentTypes)
        }
        else {
            currentTypes.push(value)
            setSelectedTypes(currentTypes)
        }
        if (mode === "create") {
            dispatch(setCustomerCreateRequestField({ field: "sqnpiAdhesionType", value: currentTypes }))
        } else {
            dispatch(setCustomerUpdateRequestField({ field: "sqnpiAdhesionType", value: currentTypes }))
        }
    }

    const customerCreateOrEditRequest = mode === "create" ? customerState.customerCreateRequest : customerState.customerUpdateRequest

    return (
        <div className="flex flex-col gap-3 border-t border-neutral-200 pt-6">
            <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">Tipo di certificazione</span>
            <MadfarmStaticSelect
                isClearable
                placeholder="Tipo Adesione"
                options={tipoSoggetto}
                defaultValue={customerCreateOrEditRequest.sqnpiSubjectType}
                value={customerCreateOrEditRequest.sqnpiSubjectType}
                onChange={(value) => {
                    //@ts-ignore
                    const newValue = value !== null ? value.value : null
                    if (mode === "create")
                        dispatch(setCustomerCreateRequestField({ field: "sqnpiSubjectType", value: newValue }))
                    else
                        dispatch(setCustomerUpdateRequestField({ field: "sqnpiSubjectType", value: newValue }))
                }}
                noOptionsMessage="Nessun tipo di certificazione trovato"
            />
            <div className="flex flex-col gap-3 w-full">
                <span className="text-center text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">Tipo Adesione</span>
                <CheckboxGroup
                    name="tipo_adesione"
                    options={Object.values(CohesionType)}
                    selectedValues={selectedTypes}
                    onChange={handleTypesChange}
                    optionLabels={{
                        [CohesionType.TERRENI]: "Terreno",
                        [CohesionType.TRASFORMAZIONE_CONFEZIONAMENTO]: "Trasformazione / Confezionamento",
                        [CohesionType.INTERMEDIAZIONE]: "Intermediazione",
                        [CohesionType.COMMERCIALIZZAZIONE_PRODOTTO_SFUSO]: "Commercializzazione Prodotto Sfuso"
                    }}
                />
            </div>
        </div>
    )
}